export function readLandingLanguage(search) {
  const params = typeof search === "string" ? new URLSearchParams(search) : search
  const raw = params?.get?.("lang")
  if (typeof raw !== "string") return "en"
  const code = raw.trim().toLowerCase()
  if (code === "en" || code === "es") return code
  return "en"
}
